import styled from "styled-components";
import { pxToRem } from "../../../Utils/helperFunctions";

export const ErrorMessageStyle = styled.span`
  color: ${props => props.theme.palette.red};
  margin-top: ${pxToRem(8)};
`;
